import { render, staticRenderFns } from "./BuySellOverview.vue?vue&type=template&id=6bbf8d2d&scoped=true"
import script from "./BuySellOverview.vue?vue&type=script&lang=js"
export * from "./BuySellOverview.vue?vue&type=script&lang=js"
import style0 from "./BuySellOverview.vue?vue&type=style&index=0&id=6bbf8d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf8d2d",
  null
  
)

export default component.exports